import { FC, Fragment } from "react";

export type ImgAvatarRoundedprops = {
  src: string | undefined;
};

export const ImgAvatarRounded: FC<ImgAvatarRoundedprops> = ({ src }) => {
  return (
    <Fragment>
      <img alt="" src={src} className="h-5 w-5 flex-shrink-0 rounded-full" />
    </Fragment>
  );
};
